import $ from 'jquery';
import Swal from 'sweetalert2';

export function initRow() {
    console.log('[ROW] initRow triggered');

    const config = window.RowConfig || {};



    // Rollback logic for /row page
    $(document).on('click', '.btn-rollback-row', function () {
        const id = $(this).data('id');
        Swal.fire({
            title: 'Rollback Status?',
            text: "Status laporan ini akan dikembalikan ke 'Waiting'. Anda yakin?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Ya, Rollback!',
            cancelButtonText: 'Batal'
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    url: config.baseUrl + 'row-approval/rollback',
                    type: 'POST',
                    data: {
                        id_row: id,
                        [document.querySelector('meta[name="X-CSRF-TOKEN-NAME"]')?.content || 'csrf_test_name']: document.querySelector('meta[name="X-CSRF-TOKEN"]')?.content
                    },
                    success: function (res) {
                        if (res.status === 'success') {
                            Swal.fire('Berhasil!', res.message, 'success').then(() => {
                                window.location.reload();
                            });
                        } else {
                            Swal.fire('Gagal!', res.message || 'Terjadi kesalahan.', 'error');
                        }
                    },
                    error: function (xhr) {
                        Swal.fire('Error!', xhr.responseJSON?.message || 'Terjadi kesalahan server.', 'error');
                    }
                });
            }
        });
    });

    // Reset modal on open
    $('#btnCreateRow').on('click', function () {
        $('#formRow')[0].reset();
        $('#id_row').val('');
        $('#modalRowTitle').text('Tambah Laporan ROW');
        $('#rowTab button:first').tab('show');
        $('.select2').val(null).trigger('change');
        $('.d-none').not('#debug-alert').addClass('d-none'); // Hide previews

        // Clear Tiang Custom Search
        $('#id_tiang_hidden').val('');
        $('#tiang_status').html('');

        // Auto-generate code if empty
        const now = new Date();
        const timestamp = now.getFullYear().toString() +
            (now.getMonth() + 1).toString().padStart(2, '0') +
            now.getDate().toString().padStart(2, '0') + '-' +
            now.getHours().toString().padStart(2, '0') +
            now.getMinutes().toString().padStart(2, '0') +
            now.getSeconds().toString().padStart(2, '0');
        $('#kode_row').val('ROW-' + timestamp);

        $('#status_label').val('Waiting').removeClass('text-success').addClass('text-warning');
        $('#status').val('Waiting');
    });

    // Auto-open edit modal if ?edit=ID is present
    const urlParams = new URLSearchParams(window.location.search);
    const editId = urlParams.get('edit');
    if (editId) {
        setTimeout(() => {
            // Create a temporary button and trigger click to reuse the existing edit logic
            const btn = $('<button>').addClass('btn-edit d-none').data('id', editId);
            $('body').append(btn);
            btn.trigger('click');
            btn.remove();
            
            // Clean up URL without reloading
            const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname;
            window.history.pushState({path:newUrl}, '', newUrl);
        }, 500);
    }

    // Tiang Check Logic (Like Inspeksi JTM)
    function checkTiang() {
        const keyword = $('#search_tiang').val().trim();
        const btn = $('#btn_check_tiang');
        const status = $('#tiang_status');
        const icon = btn.find('i');

        if (!keyword) {
            status.removeClass('text-success').addClass('text-danger').html('<i class="bi bi-exclamation-triangle-fill"></i> Masukkan nomor tiang terlebih dahulu');
            return;
        }

        // Reset hidden inputs
        $('#id_tiang_hidden').val('');
        $('#id_up3, #id_ulp, #id_penyulang, #lat, #lon').val('');
        $('#display_up3, #display_ulp, #display_penyulang').val('');

        btn.prop('disabled', true);
        icon.removeClass('bi-search').addClass('spinner-border spinner-border-sm');
        status.removeClass('text-danger text-success').addClass('text-muted').html('<i class="bi bi-hourglass-split"></i> Mencari data...');

        $.ajax({
            url: config.tiangSearchUrl,
            data: { q: keyword },
            dataType: 'json',
            success: function (res) {
                btn.prop('disabled', false);
                icon.removeClass('spinner-border spinner-border-sm').addClass('bi-search');

                if (res.status === 'success' && res.data && res.data.length > 0) {
                    const d = res.data[0];

                    $('#id_tiang_hidden').val(d.id_tiang);
                    $('#search_tiang').val(d.kode_tiang);

                    $('#id_up3').val(d.id_up3 || '');
                    $('#display_up3').val(d.nama_up3 || '-');
                    $('#id_ulp').val(d.id_ulp || '');
                    $('#display_ulp').val(d.nama_ulp || '-');
                    $('#id_penyulang').val(d.id_penyulang || '');
                    $('#display_penyulang').val(d.nama_penyulang || '-');
                    $('#lat').val(d.latitude || '');
                    $('#lon').val(d.longitude || '');

                    status.removeClass('text-danger text-muted').addClass('text-success')
                        .html(`<i class="bi bi-check-circle-fill"></i> Tiang ditemukan: ${d.kode_tiang} - ${d.nomor_tiang || ''}`);
                } else {
                    status.removeClass('text-success text-muted').addClass('text-danger')
                        .html(`<i class="bi bi-x-circle-fill"></i> Tiang dengan nomor "${keyword}" tidak ditemukan`);
                }
            },
            error: function () {
                btn.prop('disabled', false);
                icon.removeClass('spinner-border spinner-border-sm').addClass('bi-search');
                status.removeClass('text-success text-muted').addClass('text-danger')
                    .html('<i class="bi bi-x-circle-fill"></i> Terjadi kesalahan jaringan');
            }
        });
    }

    $('#btn_check_tiang').on('click', checkTiang);
    $('#search_tiang').on('keypress', function (e) {
        if (e.which == 13) {
            e.preventDefault();
            checkTiang();
        }
    });

    $('#search_tiang').on('input', function () {
        $('#id_tiang_hidden').val('');
        $('#tiang_status').html('');
        $('#display_up3, #display_ulp, #display_penyulang').val('');
    });

    $('#id_tiang').on('select2:select', function (e) {
        const d = e.params.data.full_data;
        if (!d) return;

        $('#id_up3').val(d.id_up3 || '');
        $('#display_up3').val(d.nama_up3 || 'N/A');
        $('#id_ulp').val(d.id_ulp || '');
        $('#display_ulp').val(d.nama_ulp || 'N/A');
        $('#id_penyulang').val(d.id_penyulang || '');
        $('#display_penyulang').val(d.nama_penyulang || 'N/A');
        $('#lat').val(d.latitude || '');
        $('#lon').val(d.longitude || '');
    });

    $('#id_tiang').on('select2:unselect select2:clear', function () {
        $('#id_up3, #id_ulp, #id_penyulang, #display_up3, #display_ulp, #display_penyulang, #lat, #lon').val('');
    });

    $(document).on('click', '.btn-edit', function () {
        const id = $(this).data('id');
        $.get(config.rowUrl + '/' + id + '/json', function (res) {
            if (res.status === 'success') {
                const d = res.data;
                $('#id_row').val(id);
                $('#modalRowTitle').text('Edit Laporan ROW');

                $('#tanggal').val(d.tanggal);
                $('#kode_row').val(d.kode_row);
                $('#id_pegawai').val(d.id_pegawai);
                if (d.nama_pegawai) {
                    $('#display_petugas').val(d.nama_pegawai);
                }
                $('#status').val(d.status);
                $('#status_label').val(d.status).removeClass('text-warning text-success text-danger');
                if (d.status === 'Waiting') $('#status_label').addClass('text-warning');
                if (d.status === 'Done') $('#status_label').addClass('text-success');

                if (d.id_kj) $('#id_kj').val(d.id_kj).trigger('change');
                if (d.id_zona) $('#id_zona').val(d.id_zona).trigger('change');

                if (d.id_tiang) {
                    $('#id_tiang_hidden').val(d.id_tiang);
                    $('#search_tiang').val(d.nomor_tiang || d.kode_tiang);
                    $('#alamat').val(d.alamat || '');
                    $('#tiang_status').removeClass('text-danger').addClass('text-success')
                        .html(`<i class="bi bi-check-circle-fill"></i> Tiang ditemukan: ${d.nomor_tiang || d.kode_tiang}`);

                    $('#id_up3').val(d.id_up3 || '');
                    $('#display_up3').val(d.nama_up3 || '-');
                    $('#id_ulp').val(d.id_ulp || '');
                    $('#display_ulp').val(d.nama_ulp || '-');
                    $('#id_penyulang').val(d.id_penyulang || '');
                    $('#display_penyulang').val(d.nama_penyulang || '-');

                    if (d.koordinat_tiang) {
                        const kt = d.koordinat_tiang.split(',');
                        $('#lat').val(kt[0] || '');
                        $('#lon').val(kt[1] || '');
                    }
                } else {
                    $('#id_tiang_hidden').val('');
                    $('#search_tiang').val(d.nomor_tiang || '');
                    $('#alamat').val(d.alamat || '');
                    $('#tiang_status').html('');
                }

                if (d.id_segmen) $('#id_segmen').val(d.id_segmen).trigger('change');

                $('#id_pohon').val(d.id_pohon).trigger('change');
                $('#diameter').val(d.diameter);
                $('#jenis_eksekusi').val(d.jenis_eksekusi).trigger('change');

                if (d.harga) {
                    const h = parseInt(d.harga).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
                    $('#harga').val(h);
                } else {
                    $('#harga').val('');
                }
                if (d.koordinat_pohon) {
                    const kp = d.koordinat_pohon.split(',');
                    $('#lat_pohon').val(kp[0] || '');
                    $('#lon_pohon').val(kp[1] || '');
                }
                $('#keterangan').val(d.keterangan);

                const files = ['foto_sebelum', 'foto_progres', 'foto_diameter', 'foto_sesudah'];
                files.forEach(f => {
                    const container = $('#preview-' + f);
                    if (d[f]) {
                        container.html(`<img src="${config.rowImageUrl}/${d[f]}" class="img-fluid border shadow-sm">`);
                        container.removeClass('d-none');
                    } else {
                        container.addClass('d-none').empty();
                    }
                });

                $('#modalRow').modal('show');
            }
        });
    });

    $(document).on('click', '.btn-approve', function () {
        const id = $(this).data('id');
        const level = $(this).data('level');
        const notes = [
            '',
            'Anda akan melakukan approval untuk Level 1 (Koordinator)',
            'Anda akan melakukan approval untuk Level 2 (Manager ULP)',
            'Anda akan melakukan approval untuk Level 3 (PCI / TL UP3)'
        ];

        $('#approval_id_row').val(id);
        $('#approval_level').val(level);
        $('#approval_note').text(notes[level] || 'Konfirmasi approval laporan');
        $('#approval_reason').val('');
        $('#modalApproval').modal('show');
    });

    $(document).on('change', '.file-input-preview', function () {
        const container = $('#preview-' + this.name);
        if (this.files && this.files[0]) {
            const reader = new FileReader();
            reader.onload = function (e) {
                container.html(`<img src="${e.target.result}" class="img-fluid border shadow-sm">`);
                container.removeClass('d-none');
            }
            reader.readAsDataURL(this.files[0]);
        } else {
            container.addClass('d-none').empty();
        }
    });

    $(document).on('click', '.btn-view', function () {
        const id = $(this).data('id');

        $('#modalDetail').modal('show');
        $('#detailContent').html('<div class="text-center py-5"><div class="spinner-border text-primary"></div><p class="mt-2 text-muted">Memuat data...</p></div>');

        $.get(config.rowUrl + '/' + id + '/json', function (res) {
            if (res.status === 'success') {
                const d = res.data;
                $('#detail_kode_row').text(d.kode_row);

                const formatRupiah = (val) => {
                    return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(val || 0);
                };

                let html = `
                    <div class="row g-4">
                        <div class="col-lg-4">
                            <div class="card border-0 bg-light rounded-4 h-100">
                                <div class="card-body p-4">
                                    <h6 class="text-muted x-small fw-bold text-uppercase ls-wide mb-3">Informasi Dasar</h6>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Tanggal Laporan</label>
                                        <span class="fw-bold">${d.tanggal}</span>
                                    </div>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Unit (UP3/ULP)</label>
                                        <span class="fw-bold">${d.nama_up3} / ${d.nama_ulp}</span>
                                    </div>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Kantor Jaga / Zona</label>
                                        <span class="fw-bold">${d.nama_kj || '-'} / ${d.zona || '-'}</span>
                                    </div>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Petugas</label>
                                        <span class="fw-bold text-primary">${d.nama_pegawai || '-'}</span>
                                    </div>
                                    <div class="mb-0">
                                        <label class="extra-small text-muted d-block">Status</label>
                                        <span class="badge rounded-pill ${d.status === 'Done' ? 'bg-success' : 'bg-warning text-dark'} px-3">${d.status}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-lg-4">
                            <div class="card border-0 bg-light rounded-4 h-100">
                                <div class="card-body p-4">
                                    <h6 class="text-muted x-small fw-bold text-uppercase ls-wide mb-3">Detail Lokasi & Tiang</h6>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Nomor Tiang</label>
                                        <span class="fw-bold text-dark fs-5">${d.nomor_tiang || d.kode_tiang}</span>
                                    </div>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Penyulang / Segmen</label>
                                        <span class="fw-bold">${d.nama_penyulang || '-'} / ${d.nama_segment || '-'}</span>
                                    </div>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Koordinat Tiang</label>
                                        <span class="fw-bold text-muted small">${d.koordinat_tiang || '-'}</span>
                                    </div>
                                    <div class="mb-0">
                                        <label class="extra-small text-muted d-block">Alamat / Lokasi</label>
                                        <p class="mb-0 small fw-medium">${d.alamat || '-'}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-lg-4">
                            <div class="card border-0 bg-light rounded-4 h-100 border-start border-primary border-4">
                                <div class="card-body p-4">
                                    <h6 class="text-muted x-small fw-bold text-uppercase ls-wide mb-3">Detail Pohon & Biaya</h6>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Jenis Pohon / Diameter</label>
                                        <span class="fw-bold">${d.nama_pohon || '-'} (${d.diameter || 0} cm)</span>
                                    </div>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Jenis Eksekusi</label>
                                        <span class="badge bg-primary px-3">${d.jenis_eksekusi || '-'}</span>
                                    </div>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Harga Eksekusi</label>
                                        <span class="fw-bold text-primary fs-5">${formatRupiah(d.harga)}</span>
                                    </div>
                                    <div class="mb-0">
                                        <label class="extra-small text-muted d-block">Keterangan</label>
                                        <p class="mb-0 small italic text-muted">${d.keterangan || '-'}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-12 mt-4">
                            <h6 class="text-muted x-small fw-bold text-uppercase ls-wide mb-3 ps-2">EVIDENCE</h6>
                            <div class="row g-3 text-center">
                                ${[
                        { key: 'old_foto_sebelum', label: 'SEBELUM' },
                        { key: 'old_foto_progres', label: 'PROGRES' },
                        { key: 'old_foto_diameter', label: 'DIAMETER' },
                        { key: 'old_foto_sesudah', label: 'SESUDAH' }
                    ].map(f => `
                                    <div class="col-md-3">
                                        <div class="bg-white p-2 rounded-3 shadow-sm border h-100">
                                            <label class="extra-small fw-bold text-muted text-uppercase d-block mb-2">${f.label}</label>
                                            ${d[f.key] ?
                        `<img src="${config.rowImageUrl}/${d[f.key]}" class="img-fluid rounded-2 mb-2 w-100 shadow-sm previewable-img" style="height: 180px; object-fit: cover; cursor: pointer;" onclick="window.open(this.src)" onerror="this.onerror=null; this.src='data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20width%3D%27400%27%20height%3D%27300%27%20viewBox%3D%270%200%20400%20300%27%3E%3Crect%20width%3D%27400%27%20height%3D%27300%27%20fill%3D%27%23f8f9fa%27%2F%3E%3Ctext%20x%3D%27200%27%20y%3D%27150%27%20font-family%3D%27sans-serif%27%20font-size%3D%2714%27%20fill%3D%27%23adb5bd%27%20text-anchor%3D%27middle%27%3ETidak%20Ada%20Foto%3C%2Ftext%3E%3C%2Fsvg%3E';">` :
                        `<div class="bg-light rounded-2 d-flex align-items-center justify-content-center text-muted small" style="height: 180px;"><i class="bi bi-image me-2"></i> No Photo</div>`
                    }
                                        </div>
                                    </div>
                                `).join('')}
                            </div>
                        </div>
                        
                        <div class="col-12 mt-4">
                            <h6 class="text-muted x-small fw-bold text-uppercase ls-wide mb-3 ps-2">Status Approval</h6>
                            <div class="card border-0 bg-white shadow-sm rounded-4">
                                <div class="card-body p-4 pb-1">
                                    ${[
                        { level: 'Level 1', name: d.approver_level_1 || 'Koordinator', approved_at: d.approved_koordinator_at, rejected_at: d.rejected_koordinator_at, reason: d.approved_reason_koordinator || d.rejection_reason_koordinator },
                        { level: 'Level 2', name: d.approver_level_2 || 'ULP', approved_at: d.approved_ulp_at, rejected_at: d.rejected_ulp_at, reason: d.approved_reason_ulp || d.rejection_reason_ulp },
                        { level: 'Level 3', name: d.approver_level_3 || 'UP3', approved_at: d.approved_up3_at, rejected_at: d.rejected_up3_at, reason: d.approved_reason_up3 || d.rejection_reason_up3 }
                    ].map((appr, idx, arr) => {
                        let statusColor = 'secondary';
                        let statusIcon = 'bi-hourglass-split';
                        let statusText = 'Menunggu Approval';
                        let dateText = '';

                        if (appr.approved_at) {
                            statusColor = 'success';
                            statusIcon = 'bi-check-lg';
                            statusText = 'Disetujui';
                            dateText = appr.approved_at;
                        } else if (appr.rejected_at) {
                            statusColor = 'danger';
                            statusIcon = 'bi-x-lg';
                            statusText = 'Ditolak';
                            dateText = appr.rejected_at;
                        } else if (d.status === 'Done') {
                            statusColor = 'success';
                            statusIcon = 'bi-check-lg';
                            statusText = 'Disetujui';
                            dateText = '';
                        }

                        const isLast = idx === arr.length - 1;

                        return `
                                            <div class="d-flex ${!isLast ? 'mb-0' : ''} position-relative">
                                                <div class="d-flex flex-column align-items-center me-3">
                                                    <div class="rounded-circle bg-${statusColor} d-flex align-items-center justify-content-center text-white shadow-sm" style="width: 32px; height: 32px; z-index: 2;">
                                                        <i class="bi ${statusIcon}"></i>
                                                    </div>
                                                    ${!isLast ? `<div class="bg-secondary opacity-25 flex-grow-1 my-1" style="width: 2px; min-height: 40px; z-index: 1;"></div>` : ''}
                                                </div>
                                                <div class="pb-3 w-100">
                                                    <div class="d-flex justify-content-between align-items-start">
                                                        <div class="w-100">
                                                            <h6 class="fw-bold mb-1 text-dark">${appr.name}</h6>
                                                            <p class="text-${statusColor} small fw-medium mb-1">${statusText} ${dateText ? `<span class="text-muted ms-1 fw-normal">&bull; ${dateText}</span>` : ''}</p>
                                                            ${appr.reason ? `<div class="text-muted extra-small mt-2 bg-light p-2 rounded-3 border d-inline-block"><i class="bi bi-chat-left-text me-1"></i> ${appr.reason}</div>` : ''}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        `;
                    }).join('')}
                                </div>
                            </div>
                        </div>
                    </div>
                `;
                $('#detailContent').html(html);
            } else {
                $('#modalDetail').modal('hide');
                Swal.fire('Error', res.message || 'Gagal mengambil detail data', 'error');
            }
        });
    });

    $(document).on('input', '.rp-format', function (e) {
        let val = $(this).val().replace(/[^,\d]/g, '').toString();
        let split = val.split(',');
        let sisa = split[0].length % 3;
        let rupiah = split[0].substr(0, sisa);
        let ribuan = split[0].substr(sisa).match(/\d{3}/gi);

        if (ribuan) {
            let separator = sisa ? '.' : '';
            rupiah += separator + ribuan.join('.');
        }

        rupiah = split[1] != undefined ? rupiah + ',' + split[1] : rupiah;
        $(this).val(rupiah);
    });

    // --- Chart.js Initialization ---
    function getThemeMode() {
        return document.documentElement.getAttribute('data-bs-theme') === 'dark' ? 'dark' : 'light';
    }

    let trendChart = null;
    let donutChart = null;
    let ulpChart = null;

    // --- Chart Initialization ---
    if (window.RowChartBulanan) {
        const ctxBulanan = document.getElementById('chartRowBulanan');
        if (ctxBulanan) {
            import('apexcharts').then((ApexChartsModule) => {
                const ApexCharts = ApexChartsModule.default || ApexChartsModule;
                const options = {
                    series: [{
                        name: 'Realisasi ROW',
                        data: window.RowChartBulanan
                    }],
                    chart: {
                        height: '100%',
                        type: 'area',
                        toolbar: { show: false },
                        parentHeightOffset: 0,
                    },
                    theme: { mode: getThemeMode() },
                    colors: ['#0d6efd'],
                    dataLabels: { enabled: false },
                    stroke: { curve: 'smooth', width: 3 },
                    fill: {
                        type: 'gradient',
                        gradient: {
                            shadeIntensity: 1,
                            opacityFrom: 0.4,
                            opacityTo: 0.05,
                            stops: [0, 90, 100]
                        }
                    },
                    xaxis: {
                        categories: ['Jan', 'Feb', 'Mar', 'Apr', 'Mei', 'Jun', 'Jul', 'Ags', 'Sep', 'Okt', 'Nov', 'Des'],
                        axisBorder: { show: false },
                        axisTicks: { show: false },
                        tooltip: { enabled: false }
                    },
                    yaxis: {
                        labels: {
                            formatter: function (val) {
                                return Math.round(val);
                            }
                        }
                    },
                    grid: {
                        strokeDashArray: 4,
                        xaxis: { lines: { show: false } },
                        yaxis: { lines: { show: true } },
                    },
                    legend: {
                        position: 'top',
                        horizontalAlign: 'center'
                    }
                };
                trendChart = new ApexCharts(ctxBulanan, options);
                trendChart.render();
            });
        }
    }

    const isDark = getThemeMode() === 'dark';
    const chartGridColor = isDark ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)';
    const chartTextColor = isDark ? '#adb5bd' : '#6c757d';

    if (window.RowChartUlp && typeof Chart !== 'undefined') {
        const ctxUlp = document.getElementById('chartRowUlp');
        if (ctxUlp) {
            const ulpData = window.RowChartUlp;
            const labels = ulpData.map(item => item.nama_ulp ? item.nama_ulp.toUpperCase() : 'LAINNYA');
            const data = ulpData.map(item => item.count);

            const bgColors = ['#5c6bc0', '#69f0ae', '#ff8a80', '#4dd0e1', '#ffb74d', '#ba68c8'];

            const ulpDataLabelPlugin = {
                id: 'ulpDataLabels',
                afterDatasetsDraw(chart) {
                    const { ctx } = chart;
                    const isDarkTheme = getThemeMode() === 'dark';
                    chart.data.datasets.forEach((dataset, datasetIndex) => {
                        const meta = chart.getDatasetMeta(datasetIndex);
                        meta.data.forEach((bar, index) => {
                            const value = dataset.data[index];
                            if (value === 0 || value === null) return;
                            ctx.save();
                            ctx.font = 'bold 13px Inter, sans-serif';
                            ctx.fillStyle = isDarkTheme ? '#f8f9fa' : '#333';
                            ctx.textAlign = 'center';
                            ctx.textBaseline = 'bottom';
                            ctx.fillText(value, bar.x, bar.y - 4);
                            ctx.restore();
                        });
                    });
                }
            };

            ulpChart = new Chart(ctxUlp.getContext('2d'), {
                type: 'bar',
                data: {
                    labels: labels,
                    datasets: [{
                        data: data,
                        backgroundColor: bgColors,
                        borderRadius: 4,
                        barThickness: 30,
                    }]
                },
                options: {
                    layout: { padding: { top: 20 } },
                    responsive: true,
                    maintainAspectRatio: false,
                    plugins: {
                        legend: { display: false },
                        tooltip: {
                            callbacks: {
                                label: ctx => ` ${ctx.parsed.y} kegiatan`
                            }
                        }
                    },
                    scales: {
                        y: {
                            beginAtZero: true,
                            grace: '10%',
                            grid: { color: chartGridColor },
                            ticks: { precision: 0, color: chartTextColor }
                        },
                        x: { 
                            grid: { display: false },
                            ticks: {
                                color: chartTextColor,
                                font: { size: 10 },
                                minRotation: 90,
                                maxRotation: 90
                            }
                        }
                    }
                },
                plugins: [ulpDataLabelPlugin]
            });
        }
    }

    if (window.RowDonutData && typeof Chart !== 'undefined') {
        const ctxDonut = document.getElementById('chartStatusRow');
        if (ctxDonut) {
            const data = window.RowDonutData;
            const total = data.approved + data.pending + data.reject;
            
            const centerTextPlugin = {
                id: 'centerText',
                beforeDraw: function(chart) {
                    const width = chart.width, height = chart.height, ctx = chart.ctx;
                    ctx.restore();
                    const isDarkTheme = getThemeMode() === 'dark';
                    
                    const fontSizeTotal = (height / 8).toFixed(2);
                    ctx.font = "bold " + fontSizeTotal + "px Inter, sans-serif";
                    ctx.textBaseline = "middle";
                    ctx.fillStyle = isDarkTheme ? '#f8f9fa' : "#333";
                    
                    const textTotal = total.toString();
                    const textXTotal = Math.round((width - ctx.measureText(textTotal).width) / 2);
                    const textYTotal = height / 2 - 10;
                    ctx.fillText(textTotal, textXTotal, textYTotal);

                    const fontSizeLabel = (height / 16).toFixed(2);
                    ctx.font = "500 " + fontSizeLabel + "px Inter, sans-serif";
                    ctx.fillStyle = isDarkTheme ? '#adb5bd' : "#6c757d";
                    
                    const textLabel = "Total";
                    const textXLabel = Math.round((width - ctx.measureText(textLabel).width) / 2);
                    const textYLabel = height / 2 + 15;
                    ctx.fillText(textLabel, textXLabel, textYLabel);
                    ctx.save();
                }
            };

            donutChart = new Chart(ctxDonut.getContext('2d'), {
                type: 'doughnut',
                data: {
                    labels: ['Approved', 'Pending', 'Reject'],
                    datasets: [{
                        data: [data.approved, data.pending, data.reject],
                        backgroundColor: ['#2e7d32', '#ffc107', '#d32f2f'],
                        borderWidth: 0,
                        hoverOffset: 4
                    }]
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    cutout: '75%',
                    plugins: {
                        legend: { 
                            position: 'bottom',
                            labels: {
                                color: chartTextColor,
                                usePointStyle: true,
                                padding: 15,
                                font: {
                                    size: 11
                                }
                            }
                        }
                    }
                },
                plugins: [centerTextPlugin]
            });
        }
    }

    // Dynamic Theme Update Observer
    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-bs-theme') {
                const newTheme = getThemeMode();
                const isDarkTheme = newTheme === 'dark';
                const gridColor = isDarkTheme ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.1)';
                const textColor = isDarkTheme ? '#adb5bd' : '#6c757d';

                if (trendChart) {
                    trendChart.updateOptions({ theme: { mode: newTheme } });
                }
                
                if (ulpChart) {
                    if (ulpChart.options.scales.y) {
                        ulpChart.options.scales.y.grid.color = gridColor;
                        ulpChart.options.scales.y.ticks.color = textColor;
                    }
                    if (ulpChart.options.scales.x) {
                        ulpChart.options.scales.x.ticks.color = textColor;
                    }
                    ulpChart.update();
                }
                
                if (donutChart) {
                    if (donutChart.options.plugins.legend) {
                        donutChart.options.plugins.legend.labels.color = textColor;
                    }
                    donutChart.update();
                }
            }
        });
    });
    observer.observe(document.documentElement, { attributes: true });

    // --- Export Chunk Logic ---
    $(document).on('click', '.btn-global-export', function (e) {
        e.preventDefault();
        let urlInit = $(this).data('url-init').split('?')[0];
        let urlChunk = $(this).data('url-chunk').split('?')[0];
        let urlDownload = $(this).data('url-download').split('?')[0];
        let withPhoto = $(this).data('with-photo') == '1';

        const filterParams = $('#filterForm').serialize();
        if (filterParams) {
            urlInit += '?' + filterParams;
            urlChunk += '?' + filterParams;
        }

        if (withPhoto) {
            urlInit += (urlInit.includes('?') ? '&' : '?') + 'with_photo=1';
            urlChunk += (urlChunk.includes('?') ? '&' : '?') + 'with_photo=1';
            urlDownload += (urlDownload.includes('?') ? '&' : '?') + 'with_photo=1';
        }

        $('#exportStatus').text('Menginisialisasi export...');
        $('#exportProgressBar').css('width', '0%').text('0%');
        const modalExport = new window.bootstrap.Modal(document.getElementById('modalExportProgress'));
        modalExport.show();

        $.ajax({
            url: urlInit,
            type: 'GET',
            success: function (res) {
                if (res.csrf_token) {
                    if ($('meta[name="X-CSRF-TOKEN"]').length) {
                        $('meta[name="X-CSRF-TOKEN"]').attr('content', res.csrf_token);
                    }
                    $('input[name*="csrf_"]').val(res.csrf_token);
                }

                if (res.status === 'success') {
                    processExportChunk(res.tempFile, 0, 1000, res.totalRows, urlChunk, urlDownload, modalExport);
                } else {
                    Swal.fire('Error', res.message || 'Gagal inisialisasi export', 'error');
                    modalExport.hide();
                }
            },
            error: function (xhr) {
                Swal.fire('Error', xhr.responseJSON?.message || 'Kesalahan server saat inisialisasi', 'error');
                modalExport.hide();
            }
        });
    });

    function processExportChunk(tempFile, offset, chunkSize, totalRows, urlChunk, urlDownload, modalExport) {
        if (totalRows === 0) {
            modalExport.hide();
            Swal.fire('Info', 'Tidak ada data untuk dieksport', 'info');
            return;
        }
        const csrfTokenName = $('meta[name="X-CSRF-TOKEN-NAME"]').attr('content') || 'csrf_test_name';
        const csrfHash = $('meta[name="X-CSRF-TOKEN"]').attr('content') || $('input[name*="csrf_"]').first().val();

        let postData = {
            tempFile: tempFile,
            offset: offset,
            chunkSize: chunkSize
        };

        if (csrfTokenName && csrfHash) {
            postData[csrfTokenName] = csrfHash;
        }

        $.ajax({
            url: urlChunk,
            type: 'POST',
            data: postData,
            success: function (res) {
                if (res.csrf_token) {
                    if ($('meta[name="X-CSRF-TOKEN"]').length) {
                        $('meta[name="X-CSRF-TOKEN"]').attr('content', res.csrf_token);
                    }
                    $('input[name*="csrf_"]').val(res.csrf_token);
                }

                if (res.status === 'success') {
                    let current = Math.min(offset + chunkSize, totalRows);
                    let percent = Math.round((current / totalRows) * 100);
                    $('#exportProgressBar').css('width', percent + '%').text(percent + '%');
                    $('#exportStatus').text(`Mengekspor: ${current} dari ${totalRows} baris...`);

                    if (current < totalRows) {
                        processExportChunk(tempFile, current, chunkSize, totalRows, urlChunk, urlDownload, modalExport);
                    } else {
                        $('#exportStatus').text('Selesai! Mengunduh file...');
                        setTimeout(() => {
                            modalExport.hide();
                            const separator = urlDownload.indexOf('?') !== -1 ? '&' : '?';
                            window.location.href = urlDownload + separator + 'file=' + encodeURIComponent(tempFile);
                        }, 1000);
                    }
                } else {
                    modalExport.hide();
                    Swal.fire('Error', res.message || 'Gagal mengekspor chunk', 'error');
                }
            },
            error: function (xhr) {
                modalExport.hide();
                Swal.fire('Error', xhr.responseJSON?.message || 'Kesalahan server saat mengekspor chunk', 'error');
            }
        });
    }
}

export function initRowApproval() {
    console.log('[ROW APPROVAL] initRowApproval triggered');

    const config = window.RowConfig || {};
    const levelNames = window.RowLevelNames || {};

    $(document).on('click', '.btn-rollback-row', function () {
        const id = $(this).data('id');
        Swal.fire({
            title: 'Rollback Approval?',
            text: "Status persetujuan akan dikembalikan ke 'Waiting'. Anda yakin?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Ya, Rollback!',
            cancelButtonText: 'Batal'
        }).then((result) => {
            if (result.isConfirmed) {
                $.ajax({
                    url: config.baseUrl + 'row-approval/rollback',
                    type: 'POST',
                    data: {
                        id_row: id,
                        [document.querySelector('meta[name="X-CSRF-TOKEN-NAME"]')?.content || 'csrf_test_name']: document.querySelector('meta[name="X-CSRF-TOKEN"]')?.content
                    },
                    success: function (res) {
                        if (res.status === 'success') {
                            Swal.fire('Berhasil!', res.message, 'success').then(() => {
                                window.location.reload();
                            });
                        } else {
                            Swal.fire('Gagal!', res.message || 'Terjadi kesalahan.', 'error');
                        }
                    },
                    error: function (xhr) {
                        Swal.fire('Error!', xhr.responseJSON?.message || 'Terjadi kesalahan server.', 'error');
                    }
                });
            }
        });
    });

    $(document).on('click', '.btn-view-row', function () {
        const id = $(this).data('id');
        $('#modalDetail').modal('show');
        $('#detailContent').html('<div class="text-center py-5"><div class="spinner-border text-primary"></div><p class="mt-2 text-muted">Memuat data...</p></div>');

        $.get(config.rowUrl + '/' + id + '/json', function (res) {
            if (res.status === 'success') {
                const d = res.data;
                $('#detail_kode_row').text(d.kode_row);

                const formatRupiah = (val) => {
                    return new Intl.NumberFormat('id-ID', { style: 'currency', currency: 'IDR', minimumFractionDigits: 0 }).format(val || 0);
                };

                const getSvgPlaceholder = () => `data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20width%3D%27400%27%20height%3D%27300%27%20viewBox%3D%270%200%20400%20300%27%3E%3Crect%20width%3D%27400%27%20height%3D%27300%27%20fill%3D%27%23f8f9fa%27%2F%3E%3Ctext%20x%3D%27200%27%20y%3D%27150%27%20font-family%3D%27sans-serif%27%20font-size%3D%2714%27%20fill%3D%27%23adb5bd%27%20text-anchor%3D%27middle%27%3ETidak%20Ada%20Foto%3C%2Ftext%3E%3C%2Fsvg%3E`;

                let html = `
                    <div class="row g-4">
                        <div class="col-lg-4">
                            <div class="card border-0 bg-light rounded-4 h-100">
                                <div class="card-body p-4">
                                    <h6 class="text-muted x-small fw-bold text-uppercase ls-wide mb-3">Informasi Dasar</h6>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Tanggal Laporan</label>
                                        <span class="fw-bold">${d.tanggal}</span>
                                    </div>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Unit (UP3/ULP)</label>
                                        <span class="fw-bold">${d.nama_up3} / ${d.nama_ulp}</span>
                                    </div>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Kantor Jaga / Zona</label>
                                        <span class="fw-bold">${d.nama_kj || '-'} / ${d.zona || '-'}</span>
                                    </div>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Petugas</label>
                                        <span class="fw-bold text-primary">${d.nama_pegawai || '-'}</span>
                                    </div>
                                    <div class="mb-0">
                                        <label class="extra-small text-muted d-block">Status</label>
                                        <span class="badge rounded-pill ${d.status === 'Done' ? 'bg-success' : 'bg-warning text-dark'} px-3">${d.status}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-lg-4">
                            <div class="card border-0 bg-light rounded-4 h-100">
                                <div class="card-body p-4">
                                    <h6 class="text-muted x-small fw-bold text-uppercase ls-wide mb-3">Detail Lokasi & Tiang</h6>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Nomor Tiang</label>
                                        <span class="fw-bold text-dark fs-5">${d.nomor_tiang || '-'}</span>
                                    </div>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Penyulang / Segmen</label>
                                        <span class="fw-bold">${d.nama_penyulang || '-'} / ${d.nama_segment || '-'}</span>
                                    </div>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Koordinat Tiang</label>
                                        <span class="fw-bold text-muted small">${d.koordinat_tiang || '-'}</span>
                                    </div>
                                    <div class="mb-0">
                                        <label class="extra-small text-muted d-block">Alamat / Lokasi</label>
                                        <p class="mb-0 small fw-medium">${d.alamat || '-'}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-lg-4">
                            <div class="card border-0 bg-light rounded-4 h-100 border-start border-primary border-4">
                                <div class="card-body p-4">
                                    <h6 class="text-muted x-small fw-bold text-uppercase ls-wide mb-3">Detail Pohon & Biaya</h6>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Jenis Pohon / Diameter</label>
                                        <span class="fw-bold">${d.nama_pohon || '-'} (${d.diameter || 0} cm)</span>
                                    </div>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Jenis Eksekusi</label>
                                        <span class="badge bg-primary px-3">${d.jenis_eksekusi || '-'}</span>
                                    </div>
                                    <div class="mb-3">
                                        <label class="extra-small text-muted d-block">Harga Eksekusi</label>
                                        <span class="fw-bold text-primary fs-5">${formatRupiah(d.harga)}</span>
                                    </div>
                                    <div class="mb-0">
                                        <label class="extra-small text-muted d-block">Keterangan</label>
                                        <p class="mb-0 small italic text-muted">${d.keterangan || '-'}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <div class="col-12 mt-4">
                            <h6 class="text-muted x-small fw-bold text-uppercase ls-wide mb-3 ps-2">Foto</h6>
                            <div class="row g-3 text-center">
                                ${[
                        { key: 'old_foto_sebelum', label: 'SEBELUM' },
                        { key: 'old_foto_progres', label: 'PROGRES' },
                        { key: 'old_foto_diameter', label: 'DIAMETER' },
                        { key: 'old_foto_sesudah', label: 'SESUDAH' }
                    ].map(f => `
                                    <div class="col-md-3">
                                        <div class="bg-white p-2 rounded-3 shadow-sm border h-100">
                                            <label class="extra-small fw-bold text-muted text-uppercase d-block mb-2">${f.label}</label>
                                            ${d[f.key] ?
                            `<img src="${window.RowConfig.rowImageUrl}/${d[f.key]}" class="img-fluid rounded-2 mb-2 w-100 shadow-sm previewable-img" style="height: 180px; object-fit: cover; cursor: pointer;" onclick="window.open(this.src)" onerror="this.onerror=null; this.src='${getSvgPlaceholder()}';">` :
                            `<img src="${getSvgPlaceholder()}" class="img-fluid rounded-2 mb-2 w-100 shadow-sm" style="height: 180px; object-fit: cover;">`
                        }
                                        </div>
                                    </div>
                                `).join('')}
                            </div>
                        </div>
                        
                        <div class="col-12 mt-4">
                            <h6 class="text-muted x-small fw-bold text-uppercase ls-wide mb-3 ps-2">Status Approval</h6>
                            <div class="card border-0 bg-white shadow-sm rounded-4">
                                <div class="card-body p-4 pb-1">
                                    ${[
                        { level: 'Level 1', name: d.approver_level_1 || 'Koordinator', approved_at: d.approved_koordinator_at, rejected_at: d.rejected_koordinator_at, reason: d.approved_reason_koordinator || d.rejection_reason_koordinator },
                        { level: 'Level 2', name: d.approver_level_2 || 'ULP', approved_at: d.approved_ulp_at, rejected_at: d.rejected_ulp_at, reason: d.approved_reason_ulp || d.rejection_reason_ulp },
                        { level: 'Level 3', name: d.approver_level_3 || 'UP3', approved_at: d.approved_up3_at, rejected_at: d.rejected_up3_at, reason: d.approved_reason_up3 || d.rejection_reason_up3 }
                    ].map((appr, idx, arr) => {
                        let statusColor = 'secondary';
                        let statusIcon = 'bi-hourglass-split';
                        let statusText = 'Menunggu Approval';
                        let dateText = '';

                        if (appr.approved_at) {
                            statusColor = 'success';
                            statusIcon = 'bi-check-lg';
                            statusText = 'Disetujui';
                            dateText = appr.approved_at;
                        } else if (appr.rejected_at) {
                            statusColor = 'danger';
                            statusIcon = 'bi-x-lg';
                            statusText = 'Ditolak';
                            dateText = appr.rejected_at;
                        } else if (d.status === 'Done') {
                            statusColor = 'success';
                            statusIcon = 'bi-check-lg';
                            statusText = 'Disetujui';
                            dateText = '';
                        }

                        const isLast = idx === arr.length - 1;

                        return `
                                            <div class="d-flex ${!isLast ? 'mb-0' : ''} position-relative">
                                                <div class="d-flex flex-column align-items-center me-3">
                                                    <div class="rounded-circle bg-${statusColor} d-flex align-items-center justify-content-center text-white shadow-sm" style="width: 32px; height: 32px; z-index: 2;">
                                                        <i class="bi ${statusIcon}"></i>
                                                    </div>
                                                    ${!isLast ? `<div class="bg-secondary opacity-25 flex-grow-1 my-1" style="width: 2px; min-height: 40px; z-index: 1;"></div>` : ''}
                                                </div>
                                                <div class="pb-3 w-100">
                                                    <div class="d-flex justify-content-between align-items-start">
                                                        <div class="w-100">
                                                            <h6 class="fw-bold mb-1 text-dark">${appr.name}</h6>
                                                            <p class="text-${statusColor} small fw-medium mb-1">${statusText} ${dateText ? `<span class="text-muted ms-1 fw-normal">&bull; ${dateText}</span>` : ''}</p>
                                                            ${appr.reason ? `<div class="text-muted extra-small mt-2 bg-light p-2 rounded-3 border d-inline-block"><i class="bi bi-chat-left-text me-1"></i> ${appr.reason}</div>` : ''}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        `;
                    }).join('')}
                                </div>
                            </div>
                        </div>
                    </div>
                `;
                $('#detailContent').html(html);
            } else {
                $('#modalDetail').modal('hide');
                Swal.fire('Error', res.message || 'Gagal mengambil detail data', 'error');
            }
        });
    });

    $(document).on('click', '.btn-approve', function () {
        const id = $(this).data('id');
        const level = $(this).data('level');

        let jabatanName = levelNames[level] || 'Level ' + level;

        $('#approval_id_row').val(id);
        $('#approval_level').val(level);
        $('#approval_note').text('Anda akan melakukan approval untuk ' + jabatanName);
        $('#approval_reason').val('');
        $('#modalApproval').modal('show');
    });
}

